import { useState, useCallback, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';

interface MapEvents {
  isModalOpen: boolean;
  clickedCoordinates: [number, number] | null;
  handleMapClick: (e: mapboxgl.MapMouseEvent) => void;
  handleCloseModal: () => void;
}

interface UseMapEventsOptions {
  isDrawingMode?: boolean;
}

export const useMapEvents = (options?: UseMapEventsOptions): MapEvents => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clickedCoordinates, setClickedCoordinates] = useState<[number, number] | null>(null);

  const handleMapClick = useCallback((e: mapboxgl.MapMouseEvent) => {
    // Ne pas ouvrir le modal si on est en mode dessin
    if (options?.isDrawingMode) return;
    
    // Ne pas ouvrir le modal de création si on est en train de modifier un marker
    const editModalOpen = document.querySelector('[data-modal-type="edit"]')?.getAttribute('data-open') === 'true';
    if (editModalOpen) return;

    setClickedCoordinates([e.lngLat.lng, e.lngLat.lat]);
    setIsModalOpen(true);
  }, [options?.isDrawingMode]);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    setClickedCoordinates(null);
  }, []);

  useEffect(() => {
    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isModalOpen) {
        handleCloseModal();
      }
    };

    window.addEventListener('keydown', handleEscapeKey);
    return () => window.removeEventListener('keydown', handleEscapeKey);
  }, [isModalOpen, handleCloseModal]);

  return {
    isModalOpen,
    clickedCoordinates,
    handleMapClick,
    handleCloseModal
  };
};

